"use strict";

module.exports = () => {

    let _resizeListener = (event) => {
        let win = event.target || event.srcElement;
        if (win.__resizeRAF__) {
            cancelAnimationFrame(win.__resizeRAF__);
        }
        win.__resizeRAF__ = requestAnimationFrame(() => {
            let trigger = win.__resizeTrigger__;
            trigger.__resizeListeners__.forEach((fn) => {
                fn.call(trigger, event);
            });
        });
    };

    let _objectLoad = (event) => {
        let resizeElement = event.currentTarget;
            resizeElement.contentDocument.defaultView.__resizeTrigger__ = resizeElement.__resizeElement__;
            resizeElement.contentDocument.defaultView.addEventListener('resize', _resizeListener);
    };


    return {

        addResizeListener: (element, callback) => {
            if (!element.__resizeListeners__) {
                element.__resizeListeners__ = [];
                if (getComputedStyle(element).position === 'static') {
                    element.style.position = 'relative';
                }
                let obj = element.__resizeTrigger__ = document.createElement('object');
                    obj.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1;');
                    obj.__resizeElement__ = element;
                    obj.onload = _objectLoad;
                    obj.type = 'text/html';
                    obj.data = 'about:blank';
                element.appendChild(obj);
            }
            element.__resizeListeners__.push(callback);
        },

        removeResizeListener: (element, callback) => {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(callback), 1);
            if (!element.__resizeListeners__.length) {
                if (element.__resizeTrigger__.contentDocument !== null) {
                    element.__resizeTrigger__.contentDocument.defaultView.removeEventListener('resize', _resizeListener);
                }
                element.__resizeTrigger__ = !element.removeChild(element.__resizeTrigger__);
            }
        }

    };


};